<template>
  <div v-loading="loading" class="order-details">
    <div class="box">
      <div class="title">顾客信息<span v-if="orderInfoData.phone" style="font-size: 14px;color: #FD5C8C;padding-left: 10px;cursor: pointer;" @click="customerDetails(orderInfoData.phone)">更多 <i class="el-icon-arrow-right"></i></span></div>
      <div class="memberInfo">
        <div v-if="!orderInfoData.cardNo" class="srcoll">
          <div class="i_one">
            <img :src="orderInfoData.headImgUrl ? (orderInfoData.headImgUrl+'?x-oss-process=image/resize,m_lfit,w_120,h_120') : 'static/images/head.png'" />
          </div>
          <div class="li">
            <el-tooltip effect="light" placement="top" :disabled="tooltipStatus">
              <div slot="content">
                <p>{{ orderInfoData.dtoList ? orderInfoData.dtoList.customerName ? orderInfoData.dtoList.customerName :'新增顾客' :orderInfoData.memberName ?orderInfoData.memberName : '新增顾客' }}</p>
              </div>
              <h5 @mouseover="tooltipStatus = Lib.textShow($event)">姓名：{{ orderInfoData.dtoList ? orderInfoData.dtoList.customerName ? orderInfoData.dtoList.customerName :'新增顾客' :orderInfoData.memberName ?orderInfoData.memberName : '新增顾客' }}</h5>
            </el-tooltip>
          </div>
          <div class="li">
            <h5>手机号码：{{ orderInfoData.dtoList ? orderInfoData.dtoList.customerPhone ? Lib.starPhone(orderInfoData.dtoList.customerPhone) : '--' : orderInfoData.phone ?Lib.starPhone(orderInfoData.phone) : '--' }}</h5>
          </div>
        </div>
        <div v-else class="srcoll">
          <div class="i_one">
            <img :src="orderInfoData.headImgUrl ? (orderInfoData.headImgUrl+'?x-oss-process=image/resize,m_lfit,w_120,h_120') : 'static/images/head.png'" />
          </div>
          <div class="li">
            <el-tooltip effect="light" placement="top" :disabled="tooltipStatus">
              <div slot="content">
                <p>{{ orderInfoData.memberName }}</p>
              </div>
              <h5 @mouseover="tooltipStatus = Lib.textShow($event)">
                <img v-if="orderInfoData.memberType == 1" src="@/assets/images/crown.png" />
                <img v-else-if="orderInfoData.memberType == 2" src="@/assets/images/plante.png" /> 姓名：{{ orderInfoData.memberName }}
              </h5>
            </el-tooltip>
          </div>
          <div class="li">
            <h5>手机号码：{{ Lib.starPhone(orderInfoData.phone) }}</h5>
          </div>
          <div class="li">
            <h5>会员卡号：{{ orderInfoData.cardNo }}</h5>
          </div>
        </div>
      </div>
    </div>
    <!--5.10开房信息-->
    <div v-if="roomList.customInfoList" class="box">
      <div class="title">{{ getRoomType==1?'开房信息':getRoomType==2?'床位信息':'台位信息' }}</div>
      <div class="orderInfo">
        <h3>{{ getRoomType==1?'房间名称':getRoomType==2?'床位名称':'台位名称' }}</h3>
        <h5>{{ roomList.checkinRoom.roomOrBed == 1 ? roomList.checkinRoom.roomName : (roomList.checkinRoom.roomName+'/'+roomList.checkinRoom.bedNumber) }}</h5>
        <h3>{{ roomList.infoType!=3?'预订时间':'预定时间' }}</h3>
        <h5>{{ roomList.createTime ? roomList.createTime.substring(0,16) : '--' }}</h5>
        <h3>使用时间</h3>
        <h5>{{ roomList.beginTime || '--' }}</h5>
        <h3>离店时间</h3>
        <h5>{{ roomList.endTime || '--' }}</h5>
        <h3>使用时长</h3>
        <h5>{{ roomList.dateTime || '--' }}</h5>
        <h3>状态</h3>
        <h5 v-if="roomList.infoType===2" class="themeFC">已预订</h5>
        <h5 v-if="roomList.infoType===3" class="themeFC">使用中</h5>
        <h5 v-if="roomList.infoType===5" class="themeFC">{{ getRoomType==1?'已退房':'已退位' }}</h5>
        <h5 v-if="roomList.infoType===6" class="themeFC">已过期</h5>
        <h5 v-if="roomList.infoType===7" class="themeFC">已超时</h5>
        <h5 v-if="roomList.infoType===8" class="themeFC">已取消</h5>
        <h3>备注</h3>
        <h6>{{ roomList.remarks || '--' }}</h6>
      </div>
    </div>

    <div v-if="associationList.length > 0" class="box">
      <div class="title">关联订单信息</div>
      <el-collapse v-for="(v,n) in associationList" :key="n" :accordion="true" @change="associationData(v,n)">
        <el-collapse-item>
          <template slot="title">
            <div class="collapseInfo">
              <span :style="getOrderInfo(v,2)">{{ getOrderInfo(v,1) }}</span>
              <span><samp>订单号：</samp>{{ v.orderCode }}</span>
              <span><samp>开单时间：</samp>{{ v.createTime || '--' }}</span>
              <span><samp>订单金额：</samp>￥{{ v.orderAmount }}</span>
            </div>
            <div v-if="v.orderType != 6" class="collapseBtn">
              <yz-btn type="primary" @click="seeOrder(v)">查看</yz-btn>
              <yz-btn v-if="v.orderStatus == 1 && v.orderType != 5" type="primary" @click="editOrder(v.orderId)">修改</yz-btn>
              <yz-btn v-if="v.partPayType == 1 && v.balance" type="primary" @click="settlementOrder(v.orderId,'partPay',v.orderType,v.phone)">还款</yz-btn>
            </div>
            <div v-else class="collapseBtn">
              <yz-btn type="primary" @click="seeOrder(v)">查看</yz-btn>
              <yz-btn v-if="v.bookStatus== 2" type="primary" @click="editOrder(v.orderId)">修改</yz-btn>
            </div>
          </template>
          <el-table class="collapseTable" :data="v.itemList" tooltip-effect="light">
            <el-table-column label="项目/产品/套餐" min-width="115px" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <el-tooltip v-if="scope.row.isGift===1" effect="light" placement="bottom">
                  <div slot="content">到期时间：{{ scope.row.expireTime }}</div>
                  <span class="give-icon">赠</span>
                </el-tooltip>
                <el-tooltip v-if="scope.row.isGift===2" effect="light" placement="bottom">
                  <div slot="content">到期时间：{{ scope.row.expireTime }}</div>
                  <span class="buygive-icon">买赠</span>
                </el-tooltip>
                <el-tooltip v-if="scope.row.isGift===3" effect="light" placement="bottom">
                  <div slot="content">到期时间：{{ scope.row.expireTime }}</div>
                  <span class="fullgive-icon">满赠</span>
                </el-tooltip>
                <!-- <ActivityTwo v-if="scope.row.activityType" :type="scope.row.activityType"></ActivityTwo> -->
                <span>{{ scope.row.name || '--' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="price" label="原价（元）" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <span>{{ scope.row.price }}</span>
                <el-tooltip v-if="scope.row.isUpdatePrice == 1" effect="light" placement="right">
                  <div slot="content">已改价</div>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="折后价（元）" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <span v-if="scope.row.isGift===1 || scope.row.isGift===2 || scope.row.isGift===3">0.00</span>
                <div v-else>
                  <div v-if="v.memberMsg ? (v.memberMsg.wholesaleInfo && scope.row.isWholesale == 1) ? true : false : false" style="height: 28px;line-height: 28px;">
                    <span style="float: left;line-height: 28px;">{{ scope.row.discountMoney ? (scope.row.discountMoney*1).toFixed(2) : (scope.row.price*scope.row.discount/10).toFixed(2) }}</span>
                    <el-popover placement="right" trigger="hover">
                      <div style="padding: 10px;font-size: 12px;">{{ v.memberMsg ? v.memberMsg.wholesaleInfo ? v.memberMsg.wholesaleInfo.gradeName : '' : '' }}</div>
                      <img slot="reference" style="width: 28px;height: 28px;margin-left: 5px;" src="@/assets/images/goods.png" />
                    </el-popover>
                  </div>
                  <span v-else>{{ scope.row.discountMoney ? (scope.row.discountMoney*1).toFixed(2) : (scope.row.price*scope.row.discount/10).toFixed(2) }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="count" label="数量" :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column label="小计" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <div v-if="scope.row.isGift===1">0.00</div>
                <div v-else>
                  <span v-if="scope.row.isGiftDeduct===1">0.00</span>
                  <span v-else>{{ (scope.row.deductAmount == 0 || !scope.row.deductAmount) ? scope.row.resultPrice : (scope.row.resultPrice*1-scope.row.deductAmount*1).toFixed(2) }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="优惠金额（元）" width="120px" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <div v-if="scope.row.isGift">--</div>
                <div v-else>
                  <span>{{ scope.row.totalDiscountPrice }}</span><el-tooltip v-if="(scope.row.deductDtoList ? scope.row.deductDtoList.length > 0 ? true : false : false) || (scope.row.detailList ? scope.row.detailList.length > 0 ? true : false : false)" effect="light" placement="right">
                    <div slot="content">
                      <h5 v-for="(v,n) in scope.row.deductDtoList" :key="n">{{ v.isElectronicTicketDeduct == 1 ? '电子票划扣：-￥' : v.isGiftDeduct == 1 ? '赠品划扣：-￥' : '套餐划扣：-￥' }}{{ v.deductAmount }}</h5>
                      <h5 v-for="(v,n) in scope.row.detailList" v-show="v.type != 1 && v.type != 99" :key="n">{{ v.type == 2 ? '特价活动：-￥' : v.type == 3 ? '定时打折：-￥' : v.type == 4 ? '会员优惠：-￥' : v.type == 5 ? '改价优惠：-￥' : '' }}{{ ((scope.row.price*1-v.rightsPrice*1)*v.count).toFixed(2) }}</h5>
                    </div>
                    <i class="iconfont" style="font-size: 14px;color:#d3d3d3;margin-left: 5px;">&#xe71a;</i>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="提成员工" min-width="95px">
              <template slot-scope="scope">
                <div v-if="scope.row.isGift">--</div>
                <div v-else>
                  <el-tooltip v-if="scope.row.percentage4ServeList.length > 0 && scope.row.itemType == 0" class="item" effect="light" placement="right">
                    <div slot="content" style="display: flex;">
                      <p>{{ Lib.collectively() }}：</p>
                      <div style="flex: 1;">
                        <p v-for="(item,index) in scope.row.percentage4ServeList" :key="index" style="padding: 0 10px 0 0;">
                          <span>{{ item.isGuest == 1 ?'点客':'非点客' }}-{{ item.technicianName }}<br></span>
                          <!-- <span>{{item.technicianName}}({{ item.item4ServeList[0].price }}{{item.item4ServeList[0].percentageType == 1 ? '元' : '%'}})<br></span> -->
                        </p>
                      </div>
                    </div>
                    <p style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                      <span>{{ Lib.collectively() }}：</span>
                      <span v-for="(a,b) in scope.row.percentage4ServeList" :key="b">{{ a.isGuest == 1 ?'点客':'非点客' }}-{{ a.technicianName }}{{ scope.row.percentage4ServeList.length == (b+1) ? '' : ',' }}</span>
                    </p>
                  </el-tooltip>
                  <span v-else-if="scope.row.percentage4ServeList.length == 0 && scope.row.percentageSellServeList.length == 0 && scope.row.itemType == 0">--</span>
                  <div v-if="scope.row.refundType != 1">
                    <el-tooltip v-if="scope.row.percentageSellServeList.length > 0" class="item" effect="light" placement="right">
                      <div slot="content" style="display: flex;">
                        <p>销售：</p>
                        <div style="flex: 1;">
                          <p v-for="(item,index) in scope.row.percentageSellServeList" :key="index" style="padding: 0 10px 0 0;">
                            <span>{{ item.technicianName }}<br></span>
                            <!-- <span>{{item.technicianName}}({{ item.percentageNumber }}{{item.percentageType == 1 ? '元' : '%'}})<br></span> -->
                          </p>
                        </div>
                      </div>
                      <p style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                        <span>销售：</span>
                        <span v-for="(c,d) in scope.row.percentageSellServeList" :key="d">{{ c.technicianName }}{{ scope.row.percentageSellServeList.length == (d+1) ? '' : ',' }}</span>
                      </p>
                    </el-tooltip>
                    <el-tooltip v-if="scope.row.percentageSellServeList.length == 0 && scope.row.itemType != 0" :disabled="v.orderType == 3 ? (v.percentageTechnicianName ? false : true) : (scope.row.percentageTechnicianName ? false : true)" class="item" effect="light" placement="right">
                      <div slot="content" style="display: flex;">
                        <p>{{ v.orderType == 3 ? (v.percentageTechnicianName ? ('销售：'+v.percentageTechnicianName) : '--') : (scope.row.percentageTechnicianName ? ('销售：'+scope.row.percentageTechnicianName) : '--') }}</p>
                      </div>
                      <p style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                        <span>{{ v.orderType == 3 ? (v.percentageTechnicianName ? ('销售：'+v.percentageTechnicianName) : '--') : (scope.row.percentageTechnicianName ? ('销售：'+scope.row.percentageTechnicianName) : '--') }}</span>
                      </p>
                    </el-tooltip>
                  </div>
                  <div v-else>--</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column v-if="v.orderType != 3 && v.refundStatus" label="退款类型" width="120px" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <!-- 0:退金额,1:退次数,2:退货,3:退金额退货,4:退次数退货 -->
                <span v-if="scope.row.isGift">--</span>
                <span v-else>{{ scope.row.refundType === null ? '--' : scope.row.refundType == 1 ? '退次数' : scope.row.refundType == 2 ? '退货' : scope.row.refundType == 3 ? '退金额退货' : scope.row.refundType == 4 ? '退次数退货' : '退金额' }}</span>
              </template>
            </el-table-column>
          </el-table>
        </el-collapse-item>
      </el-collapse>
    </div>

    <div v-if="associationList.length > 0" style="float: left;">
      <el-pagination background layout="prev, pager, next" style="padding: 6px 0;" :page-size="5" :total="associationOrderTotal" @current-change="handleCurrentChange"></el-pagination>
    </div>

    <div style="float: right;">
      <el-button @click="undateRoomerDetail">修改{{ Lib.returnRoomOrBed() }}信息</el-button>
      <el-button type="primary" @click="roomOutList">{{ getRoomType == 1 ? '退房' : '退位' }}</el-button>
      <el-button v-if="orderInfoData.orderRoomDetail ? orderInfoData.orderRoomDetail.customerOrderId ? true : false : false" type="primary" @click="settlementOrder(orderInfoData.orderRoomDetail.customerOrderId)">{{ getRoomType == 1 ? '退房' : '退位' }}并结账</el-button>
      <el-button v-else type="primary" @click="onBilling">开单</el-button>
    </div>

    <yzRoomDetails :show.sync="roomDetailsDialog" :detail-data="roomDetailsData" :detail-data-arr="roomDetailsData.customInfoList" :get-room-type="getRoomType" />

    <el-dialog :title="'订单号-'+orderCode+'--'+orderTypeName" :visible.sync="orderDeatilsDialog" :append-to-body="true" width="1000px">
      <yz-order-deatils :order-deatils-data="orderDeatilsData" :order-deatils-dialog="orderDeatilsDialog" :loading="loading2" @tansferDialog="getDialogData"></yz-order-deatils>
    </el-dialog>
  </div>
</template>
<script>
import { getRoomOrderItemList } from '../api';
import yzRoomDetails from './roomDetails';
import yzOrderDeatils from '../../stage/template/orderDetails/index';

export default {
  components: {
    yzRoomDetails,
    yzOrderDeatils,
  },
  props: {
    orderInfoData: {
      type: Object,
      default: Object
    },
    loading: {
      type: Boolean,
      default: false
    },
    associationList: {
      type: Array,
      default: Array
    },
    associationOrderTotal: {
      type: Number,
      default: Number
    }
  },
  data() {
    return {
      roomList: [], // 房间列表
      customerList: [], // 查看房间详情
      roomDetailsDialog: false, // 展示房间详情
      roomDetailsData: {}, // 房间详情数据
      tooltipStatus: false, // 文字过长的显示和隐藏
      getRoomType: window.sessionStorage.tidyStatus, // 设置的房态  1房间  2床位  3台位(5.10)
      menusList: [],
      IsAq: window.sessionStorage.IsAq || 1, // 安全设置-客户端签名开关
      orderCode: '',
      orderTypeName: '',
      loading2: true,
      orderDeatilsDialog: false,
      orderDeatilsData: {
        itemList: [],
        payTypeList: []
      },
    };
  },
  watch: {
    loading(val) {
      if (val == false) {
        //  房间赋值
        this.roomList = {};
        if (this.orderInfoData.orderRoomDetail) {
          this.orderInfoData.orderRoomDetail.customInfoList.forEach((list) => {
            list.orderCode = this.orderInfoData.orderRoomDetail.orderCode;
          });
          this.roomList = this.orderInfoData.orderRoomDetail; // 5.10
          this.customerList = this.orderInfoData.orderRoomDetail.customInfoList;
        } else if (this.orderInfoData.roomDetailOrder) {
          this.roomList = this.orderInfoData.roomDetailOrder;
          this.customerList = this.orderInfoData.roomDetailOrder.customerList ? this.orderInfoData.roomDetailOrder.customerList : [];
        }
      }
    },
  },
  activated() {
    this.getRoomType = window.sessionStorage.tidyStatus;// 设置的房态  1房间  2床位  3台位
    this.$emit('tansferDialog', false);
    this.menusList = JSON.parse(sessionStorage.getItem('menusList'));
  },
  methods: {
    // 切换页码
    handleCurrentChange(val) {
      const a = this.orderInfoData.orderRoomDetail.checkinRoom;
      console.log(a);
      this.$emit('fatherMethod', {
        status: 3, pageNum: val, phone: a.customerPhone, roomId: a.roomId, bedId: a.bedId, roomOrderId: a.roomOrderId
      });
    },
    // 开单
    onBilling() {
      if (this.Lib.checkPower('beauty-2-ftdd') == false) return;
      const arr = [];
      const obj = {};
      const a = this.orderInfoData.orderRoomDetail.checkinRoom;
      obj.beginTime = a.beginTime;
      obj.bookStartTime = this.orderInfoData.orderRoomDetail.bookStartTime;
      obj.customerId = a.customerId;
      obj.customerName = a.customerName || '新增顾客';
      obj.customerPhone = a.customerPhone;
      obj.customerType = a.customerType;
      if (this.getRoomType == 1) {
        const nArr = [{ name: (a.customerName || '新增顾客'), phone: a.customerPhone }];
        obj.dtoList = nArr;
      } else {
        obj.dtoList = [];
      }
      obj.endTime = a.endTime;
      obj.bookEndTime = this.orderInfoData.orderRoomDetail.bookEndTime;
      obj.roomOrderId = a.roomOrderId;
      obj.mainId = sessionStorage.getItem('mainId');
      obj.memberType = a.memberType;
      obj.remarks = a.remarks;
      obj.bedNum = a.bedNumber;
      obj.roomBedId = a.bedId;
      obj.roomId = a.roomId;
      obj.roomName = this.getRoomType == 1 ? a.roomName : (`${a.roomName}/${a.bedNumber}`);
      arr.push(obj);

      const objTwo = {};
      const roomInfo = this.orderInfoData.orderRoomDetail.checkinRoom;
      objTwo.beginTime = roomInfo.beginTime;
      objTwo.bookStartTime = this.orderInfoData.orderRoomDetail.bookStartTime;
      objTwo.buySource = 0;
      objTwo.customerName = roomInfo.customerName;
      objTwo.customerPhone = roomInfo.customerPhone;
      objTwo.endTime = roomInfo.endTime;
      objTwo.bookEndTime = this.orderInfoData.orderRoomDetail.bookEndTime;
      objTwo.roomOrderId = roomInfo.roomOrderId;
      objTwo.memberType = roomInfo.memberType;
      objTwo.roomId = roomInfo.roomId;
      objTwo.roomInfosList = arr;
      window.sessionStorage.editOrderId = '';
      window.sessionStorage.bookOrderId = '';
      this.$router.push({
        name: 'stage-serviceBilling',
        params: {
          form: objTwo
        }
      });
    },
    // 退房/退位
    roomOutList() {
      this.$emit('fatherMethod', { status: 1, obj: this.roomList });
    },
    // 修改
    undateRoomerDetail() {
      this.roomList.customInfoList.forEach((a) => {
        a.name = a.customerName;
        a.phone = a.customerPhone;
      });
      this.roomList.checkinRoom.dtoList = this.roomList.customInfoList;
      this.$emit('fatherMethod', { status: 2, obj: this.roomList });
    },
    associationData(obj, index) {
      const nData = {
        orderId: obj.orderId,
        orderType: obj.orderType
      };
      getRoomOrderItemList(nData).then((res) => {
        // eslint-disable-next-line vue/no-mutating-props
        this.associationList[index].itemList = res.data.itemList || [];
      });
    },
    // 调用公共组件--赋值
    getDialogData(list) {
      this.orderDeatilsDialog = list;
    },
    // status==1获取订单状态  status==2获取订单状态对应的颜色值
    getOrderInfo(obj, status) {
      if (obj.refundStatus != 1 && obj.refundStatus != 2) {
        if (obj.orderType != 5 && obj.orderStatus != 4) {
          if (status == 1) {
            return obj.partPayType == 1 ? '部分支付' : obj.orderStatus == 1 ? '待结算' : obj.orderStatus == 2 ? '已结算' : '部分支付';
          } if (status == 2) {
            return obj.partPayType == 1 ? 'color: #efc160;' : obj.orderStatus == 1 ? 'color: #f56c6c;' : obj.orderStatus == 2 ? 'color: #75da98;' : 'color: #efc160;';
          }
        } else if (obj.orderStatus == 4) {
          return status == 1 ? (obj.refundStatus == 3 && obj.bookStatus !== -4) ? '部分退款' : '全部退款' : 'color: #4ea5ff;';
        } else {
          if (status == 1) {
            return obj.partPayType == 3 ? '使用中' : obj.partPayType == 5 ? this.getRoomType == 1 ? '已退房' : '已退位' : '使用中';
          } if (status == 2) {
            return obj.partPayType == 3 ? 'color: #f56c6c;' : obj.partPayType == 5 ? 'color: #75da98;' : 'color: #f56c6c;';
          }
        }
      } else {
        return status == 1 ? obj.refundStatus == 1 ? '退款中' : '退款失败' : 'color: #ef8026;';
      }
    },
    // 顾客详情
    customerDetails(phone) {
      this.$emit('tansferDialog', false);
      window.sessionStorage.customerPhone = phone;
      this.$router.push({
        name: 'customer-details'
      });
    },
    // 查看房间弹框
    roommentRecords() {
      if (this.orderInfoData.orderRoomDetail) {
        this.roomDetailsData = this.orderInfoData.orderRoomDetail;
      } else {
        this.roomDetailsData = this.orderInfoData.roomDetailOrder;
      }
      this.roomDetailsDialog = true;
    },
    // 查看订单
    seeOrder(v) {
      window.sessionStorage.orderData = window.JSON.stringify(v);
      this.$router.push({
        name: 'stage-orderDeatilsData',
        params: {
          orderId: v.orderId,
          orderType: v.orderType
        }
      });
    },
    // 修改订单
    editOrder(id) {
      if (this.Lib.checkPower('beauty-2-xgdd') == false) return;
      window.sessionStorage.editOrderId = id;
      this.$router.push({
        name: 'stage-serviceBilling',
      });
    },
    // 结算订单
    settlementOrder(id, val, type, phone) {
      if (type == 3) {
        if (this.Lib.checkPower('beauty-2-jsdd') == false) return;
        window.sessionStorage.rechargePhone = phone;
        this.$router.push({
          name: 'stage-recharge',
          params: {
            partPay: 1,
            id,
            newTitle: '还款'
          }
        });
      } else {
        if (this.Lib.checkPower('beauty-2-jsdd') == false) return;
        window.sessionStorage.settlementOrderId = id;
        this.$router.push({
          name: 'stage-orderSettlement',
          params: {
            partPay: val ? 1 : 0,
            newTitle: val ? '还款' : '订单结算'
          }
        });
      }
    },
  }
};
</script>
<style lang="less" scoped>
.el-table td,
.el-table th {
  padding: 7px 0;
}
.memberInfo::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  background-color: #f5f5f5;
}
.memberInfo::-webkit-scrollbar-track-piece {
  background-color: #fff;
}
.memberInfo::-webkit-scrollbar-track {
  box-shadow: inset 0 0 10px rgba(100, 100, 100, 0.3);
  -webkit-box-shadow: inset 0 0 10px rgba(100, 100, 100, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}
.memberInfo::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 10px rgba(100, 100, 100, 0.3);
  -webkit-box-shadow: inset 0 0 10px rgba(100, 100, 100, 0.3);
  background-color: #eee;
}
.memberInfo {
  height: 80px;
  padding: 0 0 10px 0;
  width: 940px;
  overflow-x: visible;
  overflow-y: hidden;
  .srcoll {
    padding: 10px 30px;
    background-color: #f5f7fa;
    width: max-content;
    min-width: 880px;
    height: 60px;
    overflow: hidden;
    .payStatus {
      float: right;
      margin-top: -24px;
      margin-right: -25px;
      img {
        width: 60px;
        height: 60px;
        display: block;
        float: right;
        padding-right: 10px;
      }
      p {
        height: 30px;
        line-height: 30px;
        padding-right: 10px;
        font-size: 14px;
        color: #fd5c8c;
        cursor: pointer;
        float: right;
        clear: both;
      }
    }
    .i_one {
      float: left;
      width: 60px;
      height: 60px;
      line-height: 60px;
      text-align: center;
      border-radius: 50%;
      background-color: #fff;
      margin-right: 20px;
      i {
        color: #999;
        font-size: 28px;
      }
      img {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        float: left;
      }
    }
    .li {
      float: left;
      padding: 8px 30px 8px 0;
      h5 {
        img {
          width: 20px;
          margin: 12px 9px 12px 0;
          float: left;
        }
        font-size: 14px;
        color: #333;
        height: 44px;
        line-height: 44px;
        max-width: 240px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      p {
        font-size: 14px;
        color: #333;
        height: 22px;
        line-height: 22px;
        span {
          float: right;
          font-size: 12px;
          background-color: #ffe9ee;
          color: #fd5c8c;
          height: 19px;
          line-height: 19px;
          border-radius: 8px;
          margin-left: 5px;
          padding: 0 5px 0 23px;
          i {
            position: relative;
            display: block;
            float: left;
            font-size: 12px;
            margin: -2px 0 0 -25px;
            background-color: #ffe9ee;
            text-align: center;
            width: 23px;
            height: 23px;
            line-height: 23px;
            border-radius: 50%;
          }
        }
      }
    }
  }
}
.orderRemark {
  width: 940px;
  border-bottom: 1px solid #e6ebf5;
  display: flex;
  h3 {
    display: flex;
    align-items: center;
    justify-content: space-around;
    flex-direction: column;
    width: 89px;
    text-align: center;
    font-size: 14px;
    background-color: #f5f7fa;
    color: #333;
    float: left;
    border-right: 1px solid #e6ebf5;
  }
  h5 {
    display: flex;
    justify-content: space-around;
    flex-direction: column;
    width: 139px;
    padding-left: 5px;
    font-size: 14px;
    color: #333;
    float: left;
  }

  h6 {
    flex: 1;
    padding: 10px 0;
    line-height: 26px;
    padding-left: 5px;
    font-size: 14px;
    color: #333;
    float: left;
    word-wrap: break-word;
  }
}
.orderInfo {
  width: 940px;
  border-top: 1px solid #e6ebf5;
  display: table;
  .remarks{
    width: calc(100% - 100px)!important;
  }
  h2 {
    width: 140px;
    height: 32px;
    line-height: 16px;
    padding: 7px 0 7px 5px;
    font-size: 13px;
    color: #333;
    float: left;
    border-bottom: 1px solid #e6ebf5;
  }
  h3 {
    width: 89px;
    height: 46px;
    line-height: 46px;
    text-align: center;
    font-size: 14px;
    background-color: #f5f7fa;
    color: #333;
    float: left;
    border-right: 1px solid #e6ebf5;
    border-bottom: 1px solid #e6ebf5;
  }
  h4 {
    width: 139px;
    height: 46px;
    line-height: 46px;
    padding-left: 5px;
    font-size: 14px;
    color: #333;
    float: left;
    border-bottom: 1px solid #e6ebf5;
  }
  h5 {
    width: 139px;
    height: 46px;
    line-height: 46px;
    padding-left: 5px;
    font-size: 14px;
    color: #333;
    float: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-bottom: 1px solid #e6ebf5;
  }
  h6 {
    width: 375px;
    height: 46px;
    line-height: 46px;
    padding-left: 5px;
    font-size: 14px;
    color: #333;
    float: left;
    border-bottom: 1px solid #e6ebf5;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.order-details .border p label {
  color: #333 !important;
}
.autograph {
  width: 65px;
  height: 22px;
  border-radius: 5px;
  float: right;
  font-size: 12px;
  text-align: center;
  line-height: 22px;
  float: left;
  margin-right: 10px;
}
.autograph_D {
  border: 1px solid #e5e5e5;
  background-color: #f7f8fa;
  color: #999;
}
.autograph_G {
  background-color: #f0f9eb;
  border: 1px solid #e1f3d8;
  color: #67c23a;
}
.order-details{
  width: 100%;
}
.collapseInfo {
  float: left;
  padding-right: 20px;
  width: 660px;
  samp {
    color: #999;
  }
  span {
    color: #333;
  }
  span:nth-child(1) {
    float: left;
    width: 80px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  span:nth-child(2) {
    float: left;
    width: 220px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  span:nth-child(3) {
    float: left;
    width: 190px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  span:nth-child(4) {
    float: left;
    width: 170px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.collapseBtn {
  text-align: right;
  width: 176px;
}
</style>

<style>
.el-dialog__body {
  overflow-x: hidden !important;
  overflow-y: visible;
}
.order-details .el-loading-spinner {
  background-position-y: 50%;
  top: 0;
  padding-top: 0;
}
.order-details .el-collapse {
  margin-bottom: 20px;
}
.collapseTable {
  margin-bottom: -1px;
}
.collapseTable thead tr:first-child {
  background-color: #fff !important;
}
.collapseTable .el-table__header th {
  background-color: #fff !important;
}
.el-collapse-item__content {
  padding-bottom: 0;
}
</style>
